import { ROUTE_PATH } from "common/constants/sm-constants";
import { FormMetaModel, SmMetaInputModel, SmMetaSelectModel, SmBtnMetaModel } from "common/models/utility-models/meta-model";

export class TrainersMetaModel extends FormMetaModel {
    constructor() {
      super('Add Trainer', ROUTE_PATH.trainersGrid, ROUTE_PATH.trainersAdd,3, '', false, '', ' align-items-center justify-content-center',' row align-items-start justify-content-center ');
    }
  
    override initProperties(): any {
      const formInfo = super.initProperties();
      const first_name = new SmMetaInputModel(
        'first_name',
        'first_name',
        'input',
        true,
        'col-12 col-md-4',
        1,
        1,
        'First Name',
        'text',
        '[a-zA-Z][a-zA-Z ]+',
        false,
        true,
        true,
        false,
        100,
        1
      );
      const last_name = new SmMetaInputModel(
        'last_name',
        'last_name',
        'input',
        true,
        'col-12 col-md-4',
        1,
        2,
        'Last Name',
        'text',
        '[a-zA-Z][a-zA-Z ]+',
        false,
        true,
        true,
        false,
        100,
        1
      );
  
      const email = new SmMetaInputModel(
        'email',
        'email',
        'input',
        true,
        'col-12 col-md-4 ',
        2,
        3,
        'Email ID',
        'text',
        '',
        false,
        true,
        true,
        false,
        100,
        5
      );
      const mobile_number = new SmMetaInputModel(
        'mobile_number',
        'mobile_number',
        'input',
        true,
        'col-12 col-md-4 ',
        2,
        4,
        'Mobile Number',
        'number',
        '',
        false,
        true,
        true,
        false,
        10,
        1
      );
  
      const categoryIds = new SmMetaSelectModel(
        'categoryIds',
        'categoryIds',
        'ng-select',
        true,
        'col-8 ',
        3,
        5,
        'Category',
        'select',
        '',
        false,
        true,
        true,
        false,
        0,
        0,
        false,
        [],
        'category_name',
        'id',
        true,
        
      );
  
      const buttons = {
        submit: new SmBtnMetaModel('Submit', '', true, false, true, true),
        isFormControl: false,
      };
  
      return {
        formInfo,
        buttons,
        first_name,
        last_name,
        email,
        mobile_number,
        categoryIds,
      };
    }
  }